import dayjs from "dayjs";
import { merge } from "lodash";

export const deepMerge = <T extends Record<string, any>>(base: T, override: any): T => {
    return merge({}, base, override) as T;
};

export const formatDateForTooltip = (date: string): string => {
    const FORMAT = "YYYY-MM-DD";

    const formatted = dayjs(date, FORMAT, true);

    if (!formatted.isValid()) {
        return null;
    }

    return `${formatted.format("MMM YYYY")}`;
};
